import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgEyeOpened = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      d='M2.124 13.497a1 1 0 0 0 .987-.593C4.347 10.105 7.999 8.5 12 8.5s7.653 1.605 8.89 4.404a1 1 0 0 0 1.877-.136l.696-2.5a1 1 0 0 0-1.926-.536l-.104.373c-.773-.868-1.733-1.57-2.804-2.117l.35-1.676a1 1 0 0 0-1.958-.409l-.275 1.316A15.5 15.5 0 0 0 13 6.531V4.5a1 1 0 1 0-2 0v2.03a15.5 15.5 0 0 0-3.746.689l-.275-1.316a1 1 0 0 0-1.958.41l.35 1.675c-1.071.547-2.031 1.25-2.804 2.117l-.104-.373a1 1 0 0 0-1.926.536l.696 2.5a1 1 0 0 0 .89.73'
    />
    <path
      fill={props.color}
      d='M12 10c-1.154 0-2.203.29-2.957 1.043C8.289 11.797 8 12.846 8 14s.29 2.203 1.043 2.957C9.797 17.711 10.846 18 12 18s2.203-.29 2.957-1.043C15.711 16.203 16 15.154 16 14s-.29-2.203-1.043-2.957C14.203 10.289 13.154 10 12 10'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgEyeOpened)
export default ForwardRef
